import BossModel from "@/models/BossModel";

export default class AvailableDay extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/available-day';

    /**
     *
     * @type {string}
     */
    static entity = 'availableDays';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_id: this.number(null).nullable(),
            day_of_week: this.number(null).nullable(),
        }
    }
}
